import { ObsDelayStatus } from "libs/types";
import React from "react";
import styled from "styled-components";
import {IoInformationCircleOutline} from "react-icons/io5"
import CustomTooltip from "components/common/CustomTooltip";
import DevUpdateDelay from "./DevUpdateDelay";

const Container = styled.div`
  display: grid;
  grid-template-columns: 120px 160px 160px;
  gap: 2px;
  font-size: 16px;
`;

const TooltipView = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;

  svg {
    position: relative;
    top: 2px;
    font-size: 20px;
    color: ${(props) => props.theme.lightTextColor};
  }
`;

const Layout = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const SettingBtn = styled.button``;

interface DevUpdateStatusProps {
  data?: ObsDelayStatus[];
}

const DevUpdateStatus = ({data}: DevUpdateStatusProps) => {
  return <Container>
    {data?.map((obsInfo) => {
      const tooltipId = `update_status_${obsInfo.id}`
      const satImageTooltipId = `${tooltipId}_sat_image`;
      const forecastTooltipId = `${tooltipId}_forecast`;

      return <React.Fragment key={`updateStatus/${obsInfo.id}`}>
      <div>{obsInfo.country}</div>
      <Layout>
        <DevUpdateDelay text="Sat Image" type="satImage" updatedAt={obsInfo.sat_image_kor_updated_at} />
        <TooltipView className={satImageTooltipId}>
          <IoInformationCircleOutline />
          <CustomTooltip anchorSelect={`.${satImageTooltipId}`}>
            {`Last updated: ${obsInfo.sat_image_kor_updated_at}`}
          </CustomTooltip>
        </TooltipView>
      </Layout>
      <Layout>
        <DevUpdateDelay text="Hourly Forecast" type="forecast" updatedAt={obsInfo.forecast_kor_updated_at} />
        <TooltipView className={forecastTooltipId}>
          <IoInformationCircleOutline />
          <CustomTooltip anchorSelect={`.${forecastTooltipId}`}>
            {`Last updated: ${obsInfo.forecast_kor_updated_at}`}
          </CustomTooltip>
        </TooltipView>
      </Layout>
    </React.Fragment>
    })}
  </Container>
}

export default DevUpdateStatus;